var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawerCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.058 3.0606C28.6438 2.47479 28.6437 1.52504 28.0579 0.939283C27.4721 0.353528 26.5224 0.353579 25.9366 0.939397L28.058 3.0606ZM0.939283 25.9394C0.353528 26.5252 0.353579 27.475 0.939397 28.0607C1.52521 28.6465 2.47496 28.6464 3.06072 28.0606L0.939283 25.9394ZM25.9366 0.939397L0.939283 25.9394L3.06072 28.0606L28.058 3.0606L25.9366 0.939397Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.941957 3.0606C0.356203 2.47479 0.356255 1.52504 0.942072 0.939283C1.52789 0.353528 2.47764 0.353579 3.06339 0.939397L0.941957 3.0606ZM28.0607 25.9394C28.6465 26.5252 28.6464 27.475 28.0606 28.0607C27.4748 28.6465 26.525 28.6464 25.9393 28.0606L28.0607 25.9394ZM3.06339 0.939397L28.0607 25.9394L25.9393 28.0606L0.941957 3.0606L3.06339 0.939397Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerCross);
export default __webpack_public_path__ + "static/media/drawer_cross.ddfa21185610b5f2df337ce2cd90829f.svg";
export { ForwardRef as ReactComponent };